import Image from '../../Image';
import TeamAvailable from '../../../common/components/images/team-available.svg';
import TeamDefault from '../../../common/components/images/team-default.svg';
import Team2Default from '../../../common/components/images/team2-default.svg';
import IconX from '../../../common/components/images/icon-x.svg';
import IconCheck from '../../../common/components/images/icon-check.svg';
import IconDash from '../../../common/components/images/icon-dash.svg';
import { GameStatus } from '../enums';
import { useHistory, useLocation } from 'react-router-dom';
import Paginate from './Pagination';
import { useEffect } from 'react';
//import { useEffect, useState } from 'react';
import { isWithinInterval, startOfWeek, endOfWeek } from 'date-fns';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function List(props): JSX.Element {
    const { filter, setFilter, sport, data, attribute } = props;
    const location = useLocation();
    const router = useHistory();
    const pathname = location.pathname.split('/');
    const attributeUrl = pathname.length > 1 ? pathname[2] : 'arrienda';
    const urlFile = process.env.REACT_APP_URL_FILE;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handlerDefy = (e: any, type: string) => {
        //team1, team2
        const path = `/${sport}/${attributeUrl}/equipo/filter`;
        const search = `?challengeId=${e?.resumen?.challengeId || ''}&team=${type === 'team1' ? 1 : 2}&region=${
            filter?.region
        }&commune=${filter?.commune}&week=${filter?.week}&teamIdRankingFilter=${
            filter?.teamIdRankingFilter || ''
        }&teamNameRankingFilter=${filter?.teamNameRankingFilter || ''}&teamLogoRankingFilter=${
            filter?.teamLogoRankingFilter || ''
        }`;
        router.push({
            pathname: path,
            search: search,
        });
    };

    const refreshFilter = () => {
        const path = `/${sport}/${attributeUrl}/equipos/filter`;
        const search = `?region=${filter?.region}&commune=${filter?.commune}&week=${filter?.week}&limit=${
            filter?.limit !== '' && filter?.limit !== 'undefined' && filter?.limit !== null
                ? filter?.limit
                : data?.limit !== 'undefined' && data?.limit !== '' && data?.limit !== undefined
                ? data?.limit
                : ''
        }&page=${filter?.page || 1}&onlyAvailable=${filter?.onlyAvailable || ''}&teamIdRankingFilter=${
            filter?.teamIdRankingFilter || ''
        }&teamNameRankingFilter=${filter?.teamNameRankingFilter || ''}&teamLogoRankingFilter=${
            filter?.teamLogoRankingFilter || ''
        }`;
        router.push({
            pathname: path,
            search: search,
        });
    };

    useEffect(() => {
        refreshFilter();
    }, [filter]);

    const changePage = (e, page) => {
        e.preventDefault();
        const path = `/${sport}/${attributeUrl}/equipos/filter`;
        const search = `?region=${filter?.region}&commune=${filter?.commune}&week=${filter?.week}&limit=${
            filter?.limit !== '' && filter?.limit !== 'undefined' && filter?.limit !== null
                ? filter?.limit
                : data?.limit !== 'undefined' && data?.limit !== '' && data?.limit !== undefined
                ? data?.limit
                : ''
        }&page=${page}&onlyAvailable=${filter?.onlyAvailable || ''}&teamIdRankingFilter=${
            filter?.teamIdRankingFilter || ''
        }&teamNameRankingFilter=${filter?.teamNameRankingFilter || ''}&teamLogoRankingFilter=${
            filter?.teamLogoRankingFilter || ''
        }`;
        router.push({
            pathname: path,
            search: search,
        });

        setFilter({ ...filter, page: page });
    };

    return (
        <div className="mb-10">
            {/** TABLA */}
            <ul className="list-games">
                {data && data.data && data.data.length > 0 ? (
                    data?.data.map((game) => {
                        // Obtén la fecha actual
                        const today = new Date();
                        const oneWeekAgo = new Date(today);
                        oneWeekAgo.setDate(today.getDate() - 7);

                        // Calcula la fecha del lunes de la semana actual
                        const startDate = startOfWeek(oneWeekAgo, { weekStartsOn: 1 }); // 1 representa lunes

                        // Calcula la fecha del domingo de la semana actual
                        const endDate = endOfWeek(oneWeekAgo, { weekStartsOn: 1 }); // 1 representa lunes

                        if (
                            game?.resumen?.challengeId &&
                            isWithinInterval(new Date(game.resumen.date), { start: startDate, end: endDate })
                                ? game?.team1 !== null &&
                                  game?.team2 !== null &&
                                  game?.team1?.gameResult !== null &&
                                  game?.team2?.gameResult !== null
                                : true
                        ) {
                            return (
                                <li key={'item-game-' + game?.resumen?.challengeId} className="">
                                    <div
                                        className={`grid text-center items-center 
                                            grid-cols-1 justify-center 
                                            xl:grid-cols-[200px_auto_200px] lg:grid-cols-[145px_auto_145px] xl:my-0 lg:my-0 `}
                                    >
                                        <div className="lg:w-40 xl:w-[16rem] md:w-40 lg:block xl:block hidden mx-0">
                                            <hr />
                                        </div>
                                        <div className="hex gradient-border xl:w-[110%] lg:w-[110%] md:w-[100%]">
                                            <span
                                                className="hexa-text text-sm font-semibold 
                                lg:block xl:block hidden"
                                            >
                                                {`${game?.resumen?.day} / ${game?.resumen?.hour}hrs / ${
                                                    game?.resumen?.club?.name
                                                } / ${
                                                    game?.resumen?.Field?.fieldRealName
                                                        ? game?.resumen?.Field?.fieldRealName
                                                        : game?.resumen?.Field?.name
                                                }`}
                                            </span>
                                            <div className="text-sm font-semibold lg:hidden xl:hidden block">
                                                <span className="block">{`${game?.resumen?.day} / ${game?.resumen?.hour} /`}</span>
                                                <span className="block">
                                                    {`${game?.resumen?.club?.name} / ${
                                                        game?.resumen?.Field?.fieldRealName
                                                            ? game?.resumen?.Field?.fieldRealName
                                                            : game?.resumen?.Field?.name
                                                    }`}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="lg:w-[12rem] xl:w-[14.5rem] md:w-40 lg:block xl:block hidden">
                                            <hr />
                                        </div>
                                    </div>

                                    <div
                                        className={`grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 
                                          lg:grid-cols-[auto_100px_auto]
                                          xl:grid-cols-[auto_100px_auto] 
                                          text-center justify-center items-center content-center my-3 xl:my-0 lg:my-0`}
                                    >
                                        <div
                                            className={`mx-auto sport-zoom cursor-pointer w-[90%] h-[2.2rem] md:w-[22rem] flex flex-col justify-center items-center py-2 mb-1 md:mb-0 shadow-profile rounded-full hover:shadow-2xl	border-2 
    
                                            ${
                                                game?.team1
                                                    ? 'bg-sm-integrate hover:shadow-sm-integrate border-sm-integrate'
                                                    : 'bg-white hover:shadow-green-600 border-green-600'
                                            }
                                            `}
                                            onClick={() => handlerDefy(game, 'team1')}
                                        >
                                            <div
                                                className={`flex w-full relative justify-center content-center md:pl-20 `}
                                                id="team"
                                            >
                                                {/*  flex w-full relative justify-center md:justify-end content-center */}
                                                <div className={` `}>
                                                    <div
                                                        className={`flex w-full mt-0 justify-left content-end py-2 rounded-full
                                                        
                                                        
                                                        `}
                                                    >
                                                        <h1
                                                            className={` font-semibold text-[14px] leading-4 line-clamp-1 w-[200px]
                                                            ${game?.team1 ? 'text-white' : 'text-black'} `}
                                                        >
                                                            {game?.team1?.name.toUpperCase() || 'DISPONIBLE'}
                                                        </h1>
                                                        <div className="">
                                                            <Image
                                                                className={`absolute 
                                                                left-4 
                                                                -top-7
                                                                block w-auto cursor-pointer 
                                                                bg-gray-100  !rounded-full border-2 shadow-profile p-2 
                                                        ${game?.team1 ? 'border-sm-integrate' : 'border-green-600'} `}
                                                                imgClassName={`rounded-full`}
                                                                src={
                                                                    !game?.team1
                                                                        ? TeamAvailable
                                                                        : game.team1 && !game?.team1?.logo
                                                                        ? TeamDefault
                                                                        : urlFile + game?.team1?.logo
                                                                }
                                                                alt="Deporte"
                                                                height={70}
                                                                width={70}
                                                            />
                                                        </div>
                                                        {/* ICONO SOBRE EL ESTADO DEL PARTIDO */}
                                                        {game?.team1 &&
                                                            [GameStatus.WON, GameStatus.TIE, GameStatus.LOST].indexOf(
                                                                game?.team1?.gameResult,
                                                            ) > -1 && (
                                                                <div className="">
                                                                    <Image
                                                                        className="absolute
                                                                right-4
                                                                -top-[0.5px]
                                                                block w-auto cursor-pointer 
                                                                bg-gray-100  rounded-full  shadow-profile 
                                                                "
                                                                        imgClassName="h-16"
                                                                        src={
                                                                            game?.team1 &&
                                                                            game?.team1.gameResult === GameStatus.WON
                                                                                ? IconCheck
                                                                                : game?.team1 &&
                                                                                  game?.team1?.gameResult ===
                                                                                      GameStatus.LOST
                                                                                ? IconX
                                                                                : game?.team1 &&
                                                                                  game?.team1?.gameResult ===
                                                                                      GameStatus.TIE
                                                                                ? IconDash
                                                                                : ''
                                                                        }
                                                                        alt="Deporte"
                                                                        height={33}
                                                                        width={33}
                                                                    />
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mx-auto md:mx-2 sport-zoom flex flex-col justify-center items-center rounded-lg xl:py-5 lg:py-5 md:py-5 py-0 md:mb-0">
                                            <Image
                                                className="text-center text-5xl font-bold xl:w-[50px] xl:h-[50px] lg:w-[50px] lg:h-[50px] w-[44px] h-[44px] py-2"
                                                imgClassName="h-16"
                                                src={attribute.icon.image}
                                                alt="Deporte"
                                                height={35}
                                            />
                                        </div>

                                        <div
                                            className={`mx-auto sport-zoom cursor-pointer h-[2.2rem] w-[90%] md:w-[22rem] flex flex-col justify-center items-center py-2 mb-1 md:mb-0 shadow-profile border-2  rounded-full  hover:shadow-2xl 
                                          ${
                                              game?.team2
                                                  ? 'bg-sm-integrate hover:shadow-sm-integrate border-sm-integrate'
                                                  : 'bg-white hover:shadow-green-600 border-green-600'
                                          }
                                            `}
                                            onClick={() => handlerDefy(game, 'team2')}
                                        >
                                            <div
                                                className={`flex w-full relative justify-center md:pr-20 content-center`}
                                                id="team"
                                            >
                                                <div className={`items-center content-center`}>
                                                    <div
                                                        className={`flex w-full mt-0 md:mt-0 justify-center content-center `}
                                                    >
                                                        <h1
                                                            className={`   font-semibold text-[14px] leading-4 line-clamp-1 w-[180px] 
                                                            ${game?.team2 ? 'text-white' : 'text-black'} `}
                                                        >
                                                            {game?.team2?.name.toUpperCase() || 'DISPONIBLE'}
                                                        </h1>
                                                        <div className="">
                                                            <Image
                                                                className={`absolute
                                                        right-4
                                                        -top-9
                                                        block w-auto cursor-pointer 
                                                        bg-gray-100 rounded-full border-2 shadow-profile p-2
    
                                                        ${game?.team2 ? 'border-sm-integrate' : 'border-green-600'} `}
                                                                imgClassName={`rounded-full`}
                                                                src={
                                                                    !game?.team2
                                                                        ? TeamAvailable
                                                                        : game?.team2 && !game?.team2?.logo
                                                                        ? Team2Default
                                                                        : urlFile + game?.team2?.logo
                                                                }
                                                                alt="Deporte"
                                                                height={70}
                                                                width={70}
                                                            />
                                                        </div>
                                                        {/* ICONO SOBRE EL ESTADO DEL PARTIDO */}
                                                        {game?.team2 &&
                                                            [GameStatus.WON, GameStatus.TIE, GameStatus.LOST].indexOf(
                                                                game?.team2?.gameResult,
                                                            ) > -1 && (
                                                                <div className="">
                                                                    <Image
                                                                        className="absolute 
                                                    left-4 
                                                    -top-[8.5px]
                                                    block w-auto cursor-pointer 
                                                    bg-gray-100 rounded-full shadow-profile
                                                        "
                                                                        imgClassName="h-16"
                                                                        src={
                                                                            game?.team2 &&
                                                                            game?.team2.gameResult === GameStatus.WON
                                                                                ? IconCheck
                                                                                : game?.team2 &&
                                                                                  game?.team2?.gameResult ===
                                                                                      GameStatus.LOST
                                                                                ? IconX
                                                                                : game?.team2 &&
                                                                                  game?.team2?.gameResult ===
                                                                                      GameStatus.TIE
                                                                                ? IconDash
                                                                                : ''
                                                                        }
                                                                        alt="Deporte"
                                                                        height={33}
                                                                        width={33}
                                                                    />
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            );
                        }
                    })
                ) : (
                    <li key="item-game-empty ">
                        <div className="py-10 text-center">
                            <p className="hexa-text text-xl font-semibold text-white">No hay desafíos disponibles</p>
                        </div>
                    </li>
                )}
            </ul>
            {data && data.data && data.data.length > 0 && (
                <div className="pt-10">
                    <Paginate
                        pages={Number(data?.pages)}
                        page={Number(data?.page) || 1}
                        limit={5}
                        next={changePage}
                        previous={changePage}
                    />
                </div>
            )}
        </div>
    );
}
